

function BlogManagerRightNavbar() {

    return (
        <div className=''>
            <div className="rounded-none border-b bg-teal-700 border-teal-300 border-t-0 border-l-0 border-r-0">
                <div className="flex justify-end px-2 py-6">
                </div>
            </div>
        </div>
    );
}

export default BlogManagerRightNavbar;